/**
 * UDOSTEPNIJ WYNIK — Fala 4A (25.09.2026). Strona wynikow (wyniki.html.twig),
 * blok [data-udostepnij]. Ladowany automatycznie przez autoAsset() jako
 * assets/js/pages/wyniki.js.
 *
 * Dziala wylacznie po jawnym klikniecu przycisku. Kolejnosc:
 *   1. navigator.share({ title, text, url }) — gdy dostepne; anulowanie okna
 *      (AbortError) nie jest bledem i nic nie pokazuje;
 *   2. navigator.clipboard.writeText(url) — „Link skopiowany.”;
 *   3. pole tekstowe z adresem do recznego skopiowania (zaznaczone, z fokusem).
 * Adres i tekst pochodza WYLACZNIE z atrybutow data-* zlozonych w Twigu
 * (archiwum dnia PL/EN i ID losowania). Pomiar sukcesu zawiera tylko kod gry,
 * źródło i pusty przedział zestawów. Bez JS zostaje zwykły link <a href>.
 *
 * Test: node ai/test-fala-4-1-dom.js (Playwright, lokalny serwer).
 */
(function (root, doc) {
    'use strict';

    function bezpiecznyUrl(u) {
        // Tylko publiczne archiwum dnia i kotwica numeru losowania, bez danych zestawu.
        if (typeof u !== 'string' || !/^https:\/\/(?:www4\.)?pewniaki\.pl\/(?:wyniki|en\/results)\/[a-z-]+\/\d{4}-\d{2}-\d{2}(?:#losowanie-[1-9]\d*)?$/.test(u)) { return null; }
        return u;
    }

    function uruchom(box) {
        var url = bezpiecznyUrl(box.getAttribute('data-url'));
        var przycisk = box.querySelector('[data-udostepnij-przycisk]');
        var status = box.querySelector('[data-udostepnij-status]');
        var pole = box.querySelector('[data-udostepnij-pole]');
        if (!url || !przycisk || !status) { return; }
        var T = {
            skopiowano: box.getAttribute('data-t-skopiowano') || '',
            udostepniono: box.getAttribute('data-t-udostepniono') || '',
            otwarto: box.getAttribute('data-t-otwarto') || '',
            recznie: box.getAttribute('data-t-recznie') || ''
        };
        var dane = { title: box.getAttribute('data-tytul') || '', text: box.getAttribute('data-tekst') || '', url: url };
        var nav = root.navigator || {};

        function komunikat(t) { status.textContent = t; }
        function sukces(tryb, tekst) {
            komunikat(tekst); box.setAttribute('data-udostepnij-wynik', tryb);
            if (root.PewniakiZestawy) { root.PewniakiZestawy.sklep().zdarzenie('result_share', box.getAttribute('data-gra'), 'wyniki', 0); }
        }
        function recznie() {
            komunikat(T.recznie);
            if (!pole) { return; }
            pole.value = url;
            pole.hidden = false;
            try { pole.focus(); pole.select(); } catch (e) { /* bez zaznaczenia */ }
        }
        function schowek() {
            if (nav.clipboard && typeof nav.clipboard.writeText === 'function') {
                return nav.clipboard.writeText(url).then(function () { sukces('copy', T.skopiowano); }, recznie);
            }
            recznie();
            return Promise.resolve();
        }
        function udostepnij() {
            komunikat('');
            if (pole) { pole.hidden = true; }
            if (typeof nav.share === 'function') {
                var p;
                try { p = nav.share(dane); } catch (e) { p = Promise.reject(e); }
                return p.then(function () { sukces('share', T.udostepniono); }, function (e) {
                    if (e && e.name === 'AbortError') { box.setAttribute('data-udostepnij-wynik', 'cancel'); return; }
                    return schowek();
                });
            }
            return schowek();
        }
        przycisk.addEventListener('click', udostepnij);
        przycisk.hidden = false;
        var grupa = box.querySelector('[data-share-group="wyniki"]');
        if (grupa && root.PewniakiUdostepnianie) {
            root.PewniakiUdostepnianie.bind(grupa, {
                payload: dane,
                status: function (stan, dostawca, tryb) {
                    if (pole) { pole.hidden = true; }
                    if (stan === 'success') {
                        sukces('share-' + dostawca, tryb === 'copied' ? T.skopiowano : (tryb === 'popup' ? T.otwarto : T.udostepniono));
                    } else {
                        recznie();
                    }
                }
            });
        }
        box.setAttribute('data-udostepnij-tryb', typeof nav.share === 'function' ? 'share' : (nav.clipboard && typeof nav.clipboard.writeText === 'function' ? 'clipboard' : 'recznie'));
    }

    function start() {
        Array.prototype.forEach.call(doc.querySelectorAll('[data-udostepnij]'), uruchom);
    }
    if (doc.readyState === 'loading') { doc.addEventListener('DOMContentLoaded', start); } else { start(); }
})(window, document);

/* Cięższe dodatki zamkniętych sekcji wyników pobieramy dopiero przed ich
 * otwarciem. Funkcje podstawowe tabeli pozostają natychmiastowe. Po 15 s
 * bezczynności robimy zapasowe doładowanie, żeby API dodatków było dostępne
 * także dla automatyzacji i skryptów korzystających z niego bez kliknięcia. */
(function (root, doc) {
    'use strict';
    var markers = Array.prototype.slice.call(doc.querySelectorAll('[data-wyniki-leniwy]'));
    if (!markers.length) { return; }
    var loaded = Object.create(null);

    function script(src) {
        if (loaded[src]) { return loaded[src]; }
        loaded[src] = new Promise(function (resolve, reject) {
            var node = doc.createElement('script');
            node.src = src;
            node.async = false;
            node.onload = resolve;
            node.onerror = reject;
            doc.head.appendChild(node);
        });
        return loaded[src];
    }
    function load(marker) {
        if (marker.getAttribute('data-loaded') === '1') { return; }
        marker.setAttribute('data-loaded', '1');
        String(marker.getAttribute('data-src') || '').trim().split(/\s+/).filter(Boolean)
            .reduce(function (chain, src) { return chain.then(function () { return script(src); }); }, Promise.resolve())
            .catch(function () { marker.setAttribute('data-load-error', '1'); });
    }
    markers.forEach(function (marker) {
        var trigger = doc.querySelector(marker.getAttribute('data-trigger') || '');
        if (!trigger) { load(marker); return; }
        if (trigger.open) { load(marker); }
        trigger.addEventListener('toggle', function () { if (trigger.open) { load(marker); } });
        var summary = trigger.querySelector('summary');
        if (summary) {
            summary.addEventListener('pointerenter', function () { load(marker); }, { once: true, passive: true });
            summary.addEventListener('focusin', function () { load(marker); }, { once: true });
        }
    });
    root.setTimeout(function () { markers.forEach(load); }, 15000);
})(window, document);
